import { PropsWithChildren, PureComponent } from 'react';

export interface ConditionalRenderProps {
    condition: (() => boolean) | boolean | any;
}

export default class ConditionalRender extends PureComponent<PropsWithChildren<ConditionalRenderProps>> {
    render() {
        let reply = null;
        if (this.props.condition) {
            if (typeof this.props.condition === 'boolean') {
                reply = this.props.children;
            } else if (this.props.condition()) {
                reply = this.props.children;
            }
        }
        return reply;
    }
}
